import { useEffect, useState } from "react";
import WellBeEMPIService from "@services/empiService.service";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { find, forEach, isEmpty, map } from "lodash";
import { Spin } from "antd";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import DataNotFound from "@components/noDataFound";

const ChartComparisonForDifferentScoreType = () => {
  // importing states from the store
  const payer = useDataQualityReportStore((state) => state.payer);
  const fileType = useDataQualityReportStore((state) => state.fileType);
  const scoreBoardLoading = useDataQualityReportStore((state) => state.scoreBoardLoading);

  const [loading, setLoading] = useState(false);

  // creating component states
  const [categoriesOfGraph, setCategoriesOfGraph] = useState<any[]>([]);
  const [seriesOfGraph, setSeriesOfGraph] = useState<any[]>([]);

  useEffect(() => {
    setLoading(true);
    WellBeEMPIService.getScoreAnomalyGraphData(payer, fileType).subscribe({
      next: (response: any) => {
        const result = response?.data?.data?.result || {};
        const setOfDates: any[] = Object.keys(result);
        const setOfScoreType: {
          name: any;
          data: any[];
        }[] = map(result?.[setOfDates[0]], (item) => {
          return { name: item.label, data: [] };
        });

        forEach(result, (item: any, index: number) => {
          forEach(setOfScoreType, (scoreType) => {
            scoreType?.data?.push(find(item, { label: scoreType.name })?.value);
          });
        });

        setCategoriesOfGraph(setOfDates);
        setSeriesOfGraph(setOfScoreType);
        setLoading(false);
      },
      error: (error) => {
        console.log(error);
        setLoading(false);
      },
    });
  }, [fileType, payer]);

  const graphSeries = [...seriesOfGraph];

  const graphData: ApexOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
        show: false,
      },
      animations: {
        enabled: false,
        easing: "easein",
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 5,
        },
        dynamicAnimation: {
          enabled: true,
          speed: 150,
        },
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "category",
      categories: categoriesOfGraph, // using the state over here
      labels: {
        rotate: -45,
        rotateAlways: true,
      },
    },
    markers: {
      size: 5,
      shape: "circle",
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        opacityFrom: 0.6,
        opacityTo: 0.2,
        stops: [0, 100],
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value + "%";
        },
      },
    },
    tooltip: {
      enabled: true,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  };

  return (
    <Spin spinning={loading || scoreBoardLoading} indicator={<HealthemSpinner size={45} />}>
      <div id="chart">
        {
          !isEmpty(graphSeries) ? (
            <ReactApexChart options={graphData} series={graphSeries} type="area" height={350} />
          ) : (
            <DataNotFound message={loading || scoreBoardLoading ? "" : "No data found"} />
          )
        }
      </div>
      <div id="html-dist"></div>
    </Spin>
  );
};

export default ChartComparisonForDifferentScoreType;
